import React from 'react';
import { Button, Typography } from '@material-ui/core';

export default function ChooseGroupPanel({ groups = [], onSelect, disabled }) {
	return (
		<div className="w-full mt-12">
			<Typography variant="subtitle1" className="w-full text-center mb-8 opacity-80 text-xs">
				Choose a group to continue
			</Typography>

			{Array.isArray(groups) && groups.length > 0 ? (
				<div className="flex flex-wrap gap-8">
					{groups.map(group => (
						<Button
							className="flex-1"
							key={group.id ?? group.name}
							variant="contained"
							disabled={!!disabled}
							onClick={() => onSelect?.(group)}
						>
							{group.name ?? String(group.id)}
						</Button>
					))}
				</div>
			) : (
				<Typography variant="body2" className="opacity-60 text-xs text-center">
					No groups available yet.
				</Typography>
			)}
		</div>
	);
}
